import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";
import { Container, Image, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./located.css";

import backarrow from "../../../assets/images/backarrow.jpg";
import logo from "../../../assets/images/MTDlogo.png";
import responsivebg from "../../../assets/images/responsive-bg.png";


import Stepper from "../Stepper";
import * as userActions from "../../../actions/user";
import * as masterConstantActions from "../../../actions/masterConstant";

export default function Height() {
  const isFetched = useRef(false);
  const navigate = useNavigate();

  const [selectedHeight, setSelectedHeight] = useState({});
  const [heights, setHeights] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const locationSelectRef = useRef(null);

  const fetchUserGrowthsOptions = async () => {
    try {
      const response = await masterConstantActions.getConstantGrowths();
      if (response.status && response.data.length > 0) {
        setHeights(response.data);
      }
    } catch (error) {
      console.error("Error fetching growth options:", error);
    }
  };

  const fetchUserGrowths = async () => {
    try {
      const response = await userActions.getUserGrowths();
      setSelectedHeight(response?.growths?.[0]);
    } catch (error) {
      console.error("Error fetching growths:", error);
    }
  };

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;
    fetchUserGrowthsOptions();
    fetchUserGrowths();
  }, []);


  const handleHeightSelect = (height) => {
    setSelectedHeight(height);
    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedHeight?.id) {
      setErrorMessage("*Please make a selection.");
      return;
    }

    try {
      setLoading(true);
      await userActions.UpdateUserGrowths({ growthId: selectedHeight.id });
      setErrorMessage("");
      // Redirect to the next step
      navigate("/personality");
    } catch (error) {
      console.error("Error saving height:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="located-container">
      <div className="located-bg">
        <Image className="responsive-bg" src={responsivebg} />
      </div>
      <Container className="located-main">
        <Container className="located-content">
          <Container className="logo-progressbar7">
            <Container className="logo-arrow7">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="Height" />
          </Container>

          <Container>
            <div className="located-text">
              <p>How tall are you?</p>
            </div>
          </Container>

          <div className="container-div" style={{ width: "100%" }}>
            <Container className="located-details">
              <div className="container-child1">
                <Container
                  ref={locationSelectRef}
                  className="located-country collasped"
                  style={{
                    overflow: "hidden",
                    "--select-options-container-height": "20rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      locationSelectRef.current.classList.toggle("collasped")
                    }
                  >
                    <input
                      type="text"
                      placeholder="Select height"
                      value={selectedHeight?.name || ""}
                      readOnly
                      style={{
                        paddingInline: "0.5rem",
                        paddingBlock: "0.75rem",
                        width: "100%",
                        border: "none",
                        fontSize: "large",
                      }}
                    />
                    <FaAngleDown size={16} style={{ marginRight: "1rem" }} />
                  </div>
                  <div
                    className="scroll-container-vertical"
                    style={{
                      height: "13rem",
                      maxHeight: "13rem",
                    }}
                  >
                    {heights.map((height) => (
                      <div
                        key={height.id}
                        className={`scroll-item ${selectedHeight?.id === height.id ? "selected" : ""
                          }`}
                        onClick={() => {
                          handleHeightSelect(height);
                          locationSelectRef.current.classList.add("collasped");
                        }}
                      >
                        {height.name}
                      </div>
                    ))}
                  </div>
                </Container>
                {errorMessage && (
                  <p className="text-danger error-message mt-2">{errorMessage}</p>
                )}
              </div>
            </Container>
          </div>

          <div className="d-flex justify-content-center next-btn">
            <button
              type="submit"
              className="global-next-bottom-fix-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                "Next"
              )}
            </button>
          </div>
        </Container>
      </Container>
    </div>
  );
}
